import { Box } from "@mui/material";
import { DotLegalButton, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { publicRiskObservationStyles as styles } from "../PublicRiskObservation.styles";
import ReportRiskIllustration from "../reportRisk.svg?react";

export interface IWelcomeStepProps {
    onStart: () => void;
}

function WelcomeStep({ onStart }: IWelcomeStepProps) {
    const { translateString } = useTranslation();

    const benefits = ["reportObservationBenefitQuickTime", "reportObservationBenefitQuickCapture", "reportObservationBenefitObservations"];

    return (
        <>
            <Box sx={styles.content}>
                <DotLegalHeader headerStyle="xxl" marginBottom={0}>
                    {translateString("reportObservationWelcomeHeader")}
                </DotLegalHeader>
                <DotLegalHeader headerStyle="small" fontWeight={400} marginBottom={0}>
                    {translateString("reportObservationWelcomeText")}
                </DotLegalHeader>
                <Box sx={styles.welcomeIllustration}>
                    <ReportRiskIllustration width="100%" height="100%" aria-hidden />
                </Box>
                <Box component="ul" sx={styles.benefitList}>
                    {benefits.map((benefit) => (
                        <Box component="li" key={benefit} sx={styles.benefitItem}>
                            <Box sx={styles.benefitMarker} aria-hidden>
                                ✓
                            </Box>
                            <DotLegalHeader headerStyle={"small"} fontWeight={400} marginBottom={0}>
                                {translateString(benefit)}
                            </DotLegalHeader>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box sx={styles.footer}>
                <Box sx={styles.footerPrimary}>
                    <DotLegalButton buttonType="primary" size="medium" fullWidth onClick={onStart}>
                        {translateString("reportObservationStart")}
                    </DotLegalButton>
                </Box>
            </Box>
        </>
    );
}

export default WelcomeStep;
